<template>
  <div class="overview">
    <Info
      :title="learningPath.name"
      :description="learningPath.description"
      :isAuthenticated="isAuthenticated"
      :progress="overallProgress"
      :plansLink="plansLink"
      @resume-path="resumePath"
    />
    <Media
      :instructors="learningPath.instructors"
      :activities="activities"
      :isAuthenticated="isAuthenticated"
      :duration="duration"
      :difficulty="learningPath.difficulty"
      :trailerId="trailerId"
    />
  </div>
</template>

<script>
import Info from '@/components/learning-path/overview/Info.vue'
import Media from '@/components/learning-path/overview/Media.vue'

export default {
  name: 'Overview',
  components: {
    Info,
    Media,
  },
  props: {
    learningPath: {
      type: Object,
      required: true,
    },
    pathProgress: {
      type: Object,
      required: false,
    },
    nextContent: {
      type: Object,
      required: false,
    },
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    plansLink: {
      type: String,
      required: true,
    },
  },
  computed: {
    overallProgress() {
      const {
        pathProgress: { progress },
      } = this
      if (progress) {
        return progress === 1 ? 100 : parseInt(progress * 100)
      }
      return 0
    },
    activities() {
      if (this.learningPath.summary) {
        const {
          total_groups: sections,
          total_courses: courses,
          total_quizzes: quizzes,
          total_videos: videos,
          total_labs: labs,
          total_iframes: iframes,
          total_exercises: exercises,
        } = this.learningPath.summary
        return { sections, courses, quizzes, videos, labs, exercises, iframes }
      }
      return {}
    },
    duration() {
      const { duration_in_seconds: duration } = this.learningPath
      return this.$duration.durationFromSecs(duration)
    },
    trailerId() {
      const { trailer_jwplayer_id } = this.learningPath
      return trailer_jwplayer_id
    },
    learningAreaName() {
      const {
        learningPath: { learning_areas },
      } = this
      return learning_areas && learning_areas[0]
        ? learning_areas[0].name
        : 'INE'
    },
  },
  methods: {
    resumePath() {
      const { nextContent, learningAreaName } = this
      if (this.nextContent) {
        const { course, content, video } = nextContent
        const next = content || video
        switch (content.content_type) {
          case 'iframe':
            this.$store.dispatch('iframes/setPlayingIFrameId', next.id)
            break
          case 'lab':
            this.$store.dispatch('labs/setFocusLabId', next.id)
            break
          default:
            this.$store.dispatch('content/setPlayingVideoId', next.id)
            this.$store.dispatch('content/setPlayingVideoTime', 0)
            break
        }
        this.$router.push(this.$buildContentLink('course', course))
      } else {
        const {
          learningPath: { content },
        } = this
        const firstCourse = content[0].content[0]
        const { uuid: id, slug } = firstCourse
        this.$router.push(
          this.$buildContentLink('course', {
            id,
            slug,
            area: [{ name: learningAreaName }],
          })
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.overview {
  display: flex;
  flex-wrap: wrap;
  padding: 75px 25px;
  @include tablet {
    padding: 50px 100px;
    flex-wrap: nowrap;
  }
}
</style>
